import React, { useEffect, useMemo, useState } from 'react';
import { Tag } from 'antd';

import { SUB_ORDER_STATUS_MAP } from '@/config/constant';
import { IcustomerInfo, IroomInfo } from '@/redux/reducers/order';
import { renderIntlLabel } from '@/utils';
import style from './index.module.scss';

type OrderDetailTabType = 'guest' | 'bill' | 'checkRoom';

interface RoomTypeScrollProps {
  type?: OrderDetailTabType;
  extraList?: Array<IcustomerInfo>;
  checkInCustomerList?: Array<IcustomerInfo>;
  list: Array<IroomInfo>;
  onSelected: (recNo: string | number, item?: IroomInfo) => void;
}

const RoomTypeScroll: React.FC<RoomTypeScrollProps> = ({
  type = 'guest',
  extraList,
  checkInCustomerList,
  list,
  onSelected,
}) => {
  // 子单号recNo
  const [selected, setSelected] = useState<string | number>('');
  const [title, allSelectedTitle] = useMemo(() => {
    if (type === 'guest') {
      return [
        renderIntlLabel('order_roomorder_room'),
        renderIntlLabel('order_detail_label_all_rooms'),
      ];
    }
    if (type === 'bill') {
      return [
        renderIntlLabel('order_detail_label_room_bill'),
        renderIntlLabel('order_detail_label_total_account_of_order'),
      ];
    }
    if (type === 'checkRoom') {
      return [
        renderIntlLabel('order_detail_label_checkout_room'),
        renderIntlLabel('order_detail_label_all_rooms'),
      ];
    }
    return '';
  }, [type]);

  const tagColor = (status) => {
    let color = 'success';
    switch (status) {
      case 3:
        color = 'success';
        break;
      case 4:
        color = 'default';
        break;
      default:
        color = 'success';
    }
    return color;
  };

  const handleSelect = (recNo: string | number, item?: IroomInfo) => {
    setSelected(recNo);
    onSelected?.(recNo, item);
  };

  useEffect(() => {
    // 有预订人且没有入住人
    if (
      Array.isArray(extraList) &&
      extraList.length &&
      (!Array.isArray(checkInCustomerList) || !checkInCustomerList.length)
    ) {
      setSelected('reservePeople');
      onSelected?.('reservePeople');
    } else {
      setSelected('');
      onSelected?.('');
    }
  }, [extraList, checkInCustomerList]);

  return (
    <>
      <div className={style.container}>
        <div className={style.title}>{title}</div>
        <div className={style.content}>
          {Array.isArray(extraList) && extraList.length ? (
            <div
              className={`${style.btn} ${selected === 'reservePeople' ? style.selected : ''}`}
              onClick={() => handleSelect('reservePeople')}
            >
              <div>{renderIntlLabel('order_roomorder_subscriber')}</div>
            </div>
          ) : null}
          {Array.isArray(list) && list.length ? (
            <div
              className={`${style.btn} ${selected === '' ? style.selected : ''}`}
              onClick={() => handleSelect('')}
            >
              {allSelectedTitle}
            </div>
          ) : null}
          <div className={style.scrollContent}>
            {list?.map((item) => (
              <div
                key={item.recNo || item.id}
                className={`${style.btn} ${
                  selected === (item.recNo || item.id) ? style.selected : ''
                }`}
                onClick={() => handleSelect(item.recNo || item.id, item)}
              >
                <div>
                  {item.status ? (
                    // <div
                    //   className={`${style.checkIn} ${
                    //     item.status === SubOrderStatus.CheckOut ? style.checkout : ''
                    //   }`}
                    // >
                    //   {SUB_ORDER_STATUS_MAP[item.status]}
                    // </div>
                    <Tag color={tagColor(item.status)}>{SUB_ORDER_STATUS_MAP[item.status]}</Tag>
                  ) : null}
                  <div>{item.roomNo}</div>
                </div>
                <div className={style.roomName}>{item.roomTypeName}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default RoomTypeScroll;
